import { Box, Button, Divider, SvgIcon } from '@mui/material'
import { showItemList } from '../../actions/takeOff'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Can } from '../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'

const Viewer3DSvgIcon = () => (
  <SvgIcon>
    <svg
      width='33'
      height='29'
      viewBox='0 0 33 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.6445 12.4453L16.9979 17.4107V27.9996L7.6445 22.5954V12.4453Z'
        stroke='#04002E'
        strokeLinejoin='round'
      />
      <path
        d='M26.3629 12.4453L16.998 17.4107V27.9996L26.3629 22.5954V12.4453Z'
        stroke='#04002E'
        strokeLinejoin='round'
      />
      <path
        d='M7.6445 12.4448L16.9979 17.4101L26.3627 12.4448L16.9979 7.41016L7.6445 12.4448Z'
        stroke='#04002E'
        strokeLinejoin='round'
      />
      <path
        d='M17.3536 0.646445C17.1583 0.451185 16.8417 0.451185 16.6464 0.646445L13.4645 3.82843C13.2692 4.02369 13.2692 4.34026 13.4645 4.53552C13.6597 4.73079 13.9763 4.73079 14.1716 4.53552L17 1.7071L19.8284 4.53552C20.0237 4.73079 20.3403 4.73079 20.5355 4.53552C20.7308 4.34026 20.7308 4.02369 20.5355 3.82843L17.3536 0.646445ZM17.5 17V0.999995H16.5V17H17.5Z'
        fill='#04002E'
      />
      <path
        d='M0.52132 25.9396C0.44156 26.204 0.59123 26.4829 0.85561 26.5627L5.16381 27.8623C5.42821 27.9421 5.70721 27.7924 5.78691 27.528C5.86671 27.2636 5.71701 26.9847 5.45261 26.9049L1.62311 25.7497L2.77833 21.9201C2.85808 21.6558 2.70841 21.3768 2.44404 21.297C2.17966 21.2173 1.90069 21.367 1.82094 21.6313L0.52132 25.9396ZM16.7636 17.0594L0.76363 25.6434L1.23639 26.5246L17.2364 17.9406L16.7636 17.0594Z'
        fill='#04002E'
      />
      <path
        d='M32.98 25.86C33.0573 26.1251 32.9051 26.4027 32.64 26.48L28.32 27.74C28.0549 27.8173 27.7773 27.6651 27.7 27.4C27.6227 27.1349 27.7749 26.8573 28.04 26.78L31.88 25.66L30.76 21.82C30.6827 21.5549 30.8349 21.2773 31.1 21.2C31.3651 21.1227 31.6427 21.2749 31.72 21.54L32.98 25.86ZM17.2404 17.0616L32.7404 25.5616L32.2596 26.4384L16.7596 17.9384L17.2404 17.0616Z'
        fill='#04002E'
      />
    </svg>
  </SvgIcon>
)

const ItemListSvgIcon = () => (
  <SvgIcon>
    <svg
      width='23'
      height='15'
      viewBox='0 0 23 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.1758 0H3.82421C3.36901 0 3 0.369013 3 0.824214V0.824216C3 1.27942 3.36901 1.64843 3.82421 1.64843H15.1758C15.631 1.64843 16 1.27942 16 0.824214C16 0.369013 15.631 0 15.1758 0Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 0H17.8242C17.369 0 17 0.369013 17 0.824214V0.824216C17 1.27942 17.369 1.64843 17.8242 1.64843H22.1758C22.631 1.64843 23 1.27942 23 0.824214C23 0.369013 22.631 0 22.1758 0Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 0H0.824211C0.36901 0 0 0.369013 0 0.824214V0.824216C0 1.27942 0.36901 1.64843 0.824211 1.64843H1.17579C1.63099 1.64843 2 1.27942 2 0.824216V0.824214C2 0.369013 1.63099 0 1.17579 0Z'
        fill='#04002E'
      />
      <path
        d='M15.1758 2.63669H3.82421C3.36901 2.63669 3 3.0057 3 3.4609V3.4609C3 3.9161 3.36901 4.28512 3.82421 4.28512H15.1758C15.631 4.28512 16 3.9161 16 3.4609C16 3.0057 15.631 2.63669 15.1758 2.63669Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 2.63669H17.8242C17.369 2.63669 17 3.0057 17 3.4609V3.4609C17 3.9161 17.369 4.28512 17.8242 4.28512H22.1758C22.631 4.28512 23 3.9161 23 3.4609C23 3.0057 22.631 2.63669 22.1758 2.63669Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 2.63669H0.824211C0.36901 2.63669 0 3.0057 0 3.4609V3.4609C0 3.9161 0.36901 4.28512 0.824211 4.28512H1.17579C1.63099 4.28512 2 3.9161 2 3.4609V3.4609C2 3.0057 1.63099 2.63669 1.17579 2.63669Z'
        fill='#04002E'
      />
      <path
        d='M15.1758 5.27441H3.82421C3.36901 5.27441 3 5.64343 3 6.09863V6.09863C3 6.55383 3.36901 6.92284 3.82421 6.92284H15.1758C15.631 6.92284 16 6.55383 16 6.09863C16 5.64343 15.631 5.27441 15.1758 5.27441Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 5.27441H17.8242C17.369 5.27441 17 5.64343 17 6.09863V6.09863C17 6.55383 17.369 6.92284 17.8242 6.92284H22.1758C22.631 6.92284 23 6.55383 23 6.09863C23 5.64343 22.631 5.27441 22.1758 5.27441Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 5.27441H0.824211C0.36901 5.27441 0 5.64343 0 6.09863V6.09863C0 6.55383 0.36901 6.92284 0.824211 6.92284H1.17579C1.63099 6.92284 2 6.55383 2 6.09863V6.09863C2 5.64343 1.63099 5.27441 1.17579 5.27441Z'
        fill='#04002E'
      />
      <path
        d='M15.1758 8.07709H3.82421C3.36901 8.07709 3 8.4461 3 8.9013V8.9013C3 9.3565 3.36901 9.72552 3.82421 9.72552H15.1758C15.631 9.72552 16 9.3565 16 8.9013C16 8.4461 15.631 8.07709 15.1758 8.07709Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 8.07709H17.8242C17.369 8.07709 17 8.4461 17 8.9013V8.9013C17 9.3565 17.369 9.72552 17.8242 9.72552H22.1758C22.631 9.72552 23 9.3565 23 8.9013C23 8.4461 22.631 8.07709 22.1758 8.07709Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 8.07709H0.824211C0.36901 8.07709 0 8.4461 0 8.9013V8.9013C0 9.3565 0.36901 9.72552 0.824211 9.72552H1.17579C1.63099 9.72552 2 9.3565 2 8.9013V8.9013C2 8.4461 1.63099 8.07709 1.17579 8.07709Z'
        fill='#04002E'
      />
      <path
        d='M15.1758 10.7139H3.82421C3.36901 10.7139 3 11.0829 3 11.5381V11.5381C3 11.9933 3.36901 12.3623 3.82421 12.3623H15.1758C15.631 12.3623 16 11.9933 16 11.5381C16 11.0829 15.631 10.7139 15.1758 10.7139Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 10.7139H17.8242C17.369 10.7139 17 11.0829 17 11.5381V11.5381C17 11.9933 17.369 12.3623 17.8242 12.3623H22.1758C22.631 12.3623 23 11.9933 23 11.5381C23 11.0829 22.631 10.7139 22.1758 10.7139Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 10.7139H0.824211C0.36901 10.7139 0 11.0829 0 11.5381V11.5381C0 11.9933 0.36901 12.3623 0.824211 12.3623H1.17579C1.63099 12.3623 2 11.9933 2 11.5381V11.5381C2 11.0829 1.63099 10.7139 1.17579 10.7139Z'
        fill='#04002E'
      />
      <path
        d='M15.1758 13.3516H3.82421C3.36901 13.3516 3 13.7206 3 14.1758V14.1758C3 14.631 3.36901 15 3.82421 15H15.1758C15.631 15 16 14.631 16 14.1758C16 13.7206 15.631 13.3516 15.1758 13.3516Z'
        fill='#04002E'
      />
      <path
        d='M22.1758 13.3516H17.8242C17.369 13.3516 17 13.7206 17 14.1758V14.1758C17 14.631 17.369 15 17.8242 15H22.1758C22.631 15 23 14.631 23 14.1758C23 13.7206 22.631 13.3516 22.1758 13.3516Z'
        fill='#04002E'
      />
      <path
        d='M1.17579 13.3516H0.824211C0.36901 13.3516 0 13.7206 0 14.1758V14.1758C0 14.631 0.36901 15 0.824211 15H1.17579C1.63099 15 2 14.631 2 14.1758V14.1758C2 13.7206 1.63099 13.3516 1.17579 13.3516Z'
        fill='#04002E'
      />
    </svg>
  </SvgIcon>
)

const ItemListSwitcher = () => {
  const dispatch = useDispatch<any>()

  const isItemListPresented = useSelector(
    (state: RootState) => state.takeOff.isItemListPresented,
  )

  return (
    <Can I={AttributeActionNames.Read} a={AttributeResourceNames.TakeOff}>
      <Box
        sx={{
          width: 'fit-content',
          backgroundColor: '#FFFFFF',
          borderRadius: '6px',
          padding: '2px',
          display: 'flex',
          gap: '6px',
          pointerEvents: 'auto',
          boxShadow: '0px 2.642px 4.403px 0px rgba(47, 47, 47, 0.25)',
        }}
      >
        <Button
          fullWidth
          variant='contained'
          disableElevation
          onClick={() => {
            dispatch(showItemList(false))
          }}
          sx={{
            minWidth: '55px',
            height: '34px',
            backgroundColor: !isItemListPresented ? '#E5F0FF' : 'transparent',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            padding: 0,
            lineHeight: 'normal',
          }}
        >
          <Viewer3DSvgIcon />
        </Button>

        <Divider
          orientation='vertical'
          flexItem
          sx={{
            borderColor: '#EFEFEF',
            borderBottomWidth: 1,
          }}
        />

        <Button
          fullWidth
          variant='contained'
          disableElevation
          onClick={() => {
            dispatch(showItemList(true))
          }}
          sx={{
            minWidth: '55px',
            height: '34px',
            backgroundColor: isItemListPresented ? '#E5F0FF' : 'transparent',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            padding: 0,
            lineHeight: 'normal',
          }}
        >
          <ItemListSvgIcon />
        </Button>
      </Box>
    </Can>
  )
}

export default ItemListSwitcher
